<template>
  <v-container>
    <v-row id="plays">
      <v-col cols="12">
        <h4 class="overline mb-1 d-flex">Penetration Testing Plays</h4>
        <v-card id="playTable" flat color="bg_darkerish">
          <v-card-title class="font-weight-light pt-0 pb-2">
            <v-row no-gutters>
              <v-col cols="12" order="1" sm="6" order-sm="1" class="px-2">
                <v-select
                  v-model="capecFilters"
                  :items="capecOptions"
                  @change="searchAndFilter"
                  multiple
                  label="Filter by CAPEC Attack Pattern"
                  color="dw_green"
                  item-color="dw_green"
                  item-text="name"
                  item-value="id"
                  return-object
                  single-line
                  hide-details
                  clearable
                  :clear-icon="mdiClose"
                  class="text-caption"
                ></v-select>
              </v-col>
              <v-col cols="12" order="4" sm="6" order-sm="2" class="px-2">
                <v-text-field
                  v-model="search"
                  @keydown.enter="searchAndFilter"
                  label="Search"
                  color="dw_green"
                  clearable
                  @click:clear="() => search === null ? searchAndFilter : null"
                  :clear-icon="mdiClose"
                  single-line
                  hide-details
                  class="text-caption">
                  <template v-slot:append>
                    <v-icon small class="ml-1" v-text="mdiLayersSearchOutline" />
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" order="2" sm="6" order-sm="3" class="px-2">
                <v-select
                  v-model="objFilters"
                  :items="objectiveOptions"
                  @change="searchAndFilter"
                  multiple
                  label="Filter by Objective"
                  color="dw_green"
                  item-color="dw_green"
                  item-text="title"
                  return-object
                  single-line
                  hide-details
                  clearable
                  :clear-icon="mdiClose"
                  class="text-caption"
                ></v-select>
              </v-col>
              <v-col cols="12" order="3" sm="6" order-sm="4" class="px-2">
                <v-select
                  v-model="tagFilters"
                  :items="tagOptions"
                  @change="searchAndFilter"
                  multiple
                  label="Filter by Tag"
                  color="dw_green"
                  item-color="dw_green"
                  item-text="name"
                  return-object
                  single-line
                  hide-details
                  clearable
                  :clear-icon="mdiClose"
                  class="text-caption"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="plays"
            :items-per-page.sync="itemsPerPage"
            :page.sync="pageNum"
            :single-select="true"
            @click:row="(rowItem, { select }) => select(rowItem)"
            @item-selected="({ item }) =>
              $router.push({ name: 'play_view', params: { id: item.id }})"
            item-key="id"
            show-select
            class="elevation-1 bg_darkerish"
            hide-default-footer
          >
            <template v-slot:no-data>
              <div class="font-weight-light text-start">No Plays found</div>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <div @click="select">
                <v-icon v-if="isSelected" small color="dw_green" v-text="mdiRecordCircleOutline" />
                <v-icon v-else small color="white" v-text="mdiCircleOutline" />
              </div>
            </template>
            <template v-slot:item.id="{ value }">
              <div class="font-weight-light">{{ value }}</div>
            </template>
            <template v-slot:item.name="{ value }">
              <div
                class="font-weight-light d-inline-block text-wrap text-truncate"
                style="max-width: 30vw;">{{ value }}</div>
            </template>
            <template v-slot:item.description="{ value }">
              <div
                class="font-weight-light d-inline-block text-wrap text-truncate"
                style="max-width: 20vw;">{{ value }}</div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                v-text="mdiPlusCircleOutline"
                small
                color="dw_green"
                @click.stop="scenarioBuilderPlay(item)"
                title="Add to the Scenario" />
              <v-icon
                v-text="mdiLayersTripleOutline"
                small
                color="dw_green"
                class="ml-2"
                @click.stop="exportLayer(item.id)"
                title="Export to ATT&CK Navigator Layer" />
            </template>

            <template v-slot:footer>
              <v-divider></v-divider>
              <v-row class="caption pa-2" no-gutters align="center" justify="center">
                <v-col cols="4" class="d-flex ml-2">
                  <v-row no-gutters align-content="start">
                    <v-col  cols="6" align-self="center">
                      <span class="grey--text">Rows per page:</span>
                    </v-col>
                    <v-col cols="4">
                      <v-select
                        dense
                        v-model="itemsPerPage"
                        :items="perPage"
                        item-text="text"
                        item-value="value"
                        color="dw_green"
                        item-color="dw_green"
                        single-line
                        hide-details
                        title="Rows per Page"
                        class="ml-2 pb-1 pl-1 my-auto caption"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <span class="mx-4 grey--text">
                  {{ pageStart + 1 }}-{{ pageStop }} of {{ playCount }}
                </span>
                <v-btn
                  fab
                  x-small
                  text
                  class="mr-1"
                  title="Previous Page"
                  :disabled="prevPageDisabled"
                  @click="goToPrevPage">
                  <v-icon small v-text="mdiChevronLeft" />
                </v-btn>
                <v-btn
                  fab
                  x-small
                  text
                  class="mr-1"
                  title="Next Page"
                  :disabled="nextPageDisabled"
                  @click="goToNextPage">
                  <v-icon small v-text="mdiChevronRight" />
                </v-btn>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <router-view
      @filter-by-tag="filterByTag"
      @filter-by-obj="filterByObj"
      :filters="{ tags: tagFilters, objctvs: objFilters }"
      @export-layer="exportLayer"
    ></router-view>
    <v-snackbar v-model="snackbar" top outlined timeout="2000" color="dw_green">
      <p class="mb-0 white--text">{{ snackmsg }}</p>
      <template v-slot:action>
        <v-btn
          @click="snackbar = false"
          text
          small
          color="dw_green"
          class="my-auto"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  mdiLayersSearchOutline,
  mdiCircleOutline,
  mdiRecordCircleOutline,
  mdiClose,
  mdiChevronLeft,
  mdiChevronRight,
  mdiPlusCircleOutline,
  mdiLayersTripleOutline
} from '@mdi/js';
import apiService from '@/services/api.service';
import navLayerMethods from '@/utils/generateNavigatorLayer';

export default {
  name: 'playPanel',
  data() {
    return {
      mdiLayersSearchOutline,
      mdiCircleOutline,
      mdiRecordCircleOutline,
      mdiClose,
      mdiChevronLeft,
      mdiChevronRight,
      mdiPlusCircleOutline,
      mdiLayersTripleOutline,
      capecFilters: [],
      tagFilters: [],
      objFilters: [],
      search: '',
      snackbar: false,
      snackmsg: '',
      headers: [
        {
          text: 'Dark Wolf Play ID',
          value: 'id',
          align: 'start',
          width: '10vw',
          sortable: false,
          class: 'font-weight-regular'
        },
        {
          text: 'Name',
          value: 'name',
          width: '30vw',
          sortable: false,
          class: 'font-weight-regular'
        },
        {
          text: 'Description',
          value: 'description',
          width: '20vw',
          sortable: false,
          class: 'font-weight-regular'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          width: '10vw',
          sortable: false,
          class: 'font-weight-regular'
        }
      ],
      itemsPerPage: 5,
      perPage: [
        { text: '5', value: 5 },
        { text: '25', value: 25 }
      ],
      pageNum: 1,
      numTablePages: 1,
      pageStart: 0,
      pageStop: 5,
      playCount: 0,
      queryPrevPage: null,
      queryNextPage: null,
      queryPrevOffset: 0,
      queryCurrentOffset: 0,
      queryNextOffset: 25,
      prevPageDisabled: true,
      nextPageDisabled: false
    };
  },
  watch: {
    search() {
      if (this.search === null) {
        this.search = '';
        this.searchAndFilter();
      }
    },
    playPagination() {
      this.handlePagination();
    },
    itemsPerPage() {
      this.pageNum = 1;
      this.handlePagination();
    }
  },
  computed: {
    ...mapGetters([
      'plays',
      'playPagination',
      'capecOptions',
      'tagOptions',
      'objectiveOptions'
    ])
  },
  mounted() {
    if (this.playPagination.count) this.handlePagination();
  },
  methods: {
    ...navLayerMethods,
    ...mapActions([
      'fetchPlays',
      'updateScenarioBuilder'
    ]),
    ...mapMutations([
      'throwError'
    ]),
    filterByTag(type, tag) {
      if (type === 'add' && !this.tagFilters.some((fltr) => fltr.id === tag.id)) {
        this.tagFilters.push(tag);
      } else {
        this.tagFilters = this.tagFilters.filter((fltr) => fltr.id !== tag.id);
      }
      this.searchAndFilter();
      this.$vuetify.goTo('#playTable');
    },
    filterByObj(type, objctv) {
      if (type === 'add' && !this.objFilters.some((fltr) => fltr.id === objctv.id)) {
        this.objFilters.push(objctv);
      } else {
        this.objFilters = this.objFilters.filter((fltr) => fltr.id !== objctv.id);
      }
      this.searchAndFilter();
      this.$vuetify.goTo('#playTable');
    },
    async scenarioBuilderPlay(item) {
      try {
        const play = await apiService.get(`plays/${item.id}/`);
        this.updateScenarioBuilder(['add', play]);
        this.snackbar = true;
        this.snackmsg = `${item.id} Added`;
      } catch {
        this.throwError('Unable to add play to the Scenario Builder');
      }
    },
    async exportLayer(id) {
      let play;
      try {
        play = await apiService.get(`plays/${id}/`);
      } catch {
        this.throwError('Unable to retrieve play information');
        return;
      }
      let layerJSON;
      const isMobile = play.techniques.some((tq) => tq.matrix_type === 'mobile');
      try {
        if (isMobile) {
          layerJSON = await this.exportMobileLayer(
            play.id,
            play.techniques
          );
        } else {
          layerJSON = await this.exportEnterpriseLayer(
            play.id,
            play.techniques
          );
        }
      } catch {
        this.throwError('Unable to export play to ATT&CK Navigator Layer');
        return;
      }
      const filename = `${play.id}.layer.json`;
      const contentType = 'application/json;charset=utf-8;';
      const a = document.createElement('a');
      a.download = filename;
      a.href = `data:${contentType},${encodeURIComponent(JSON.stringify(layerJSON))}`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async searchAndFilter() {
      let endpoint = '?ordering=id';
      endpoint += this.search.length > 1 ? `&search=${this.search}` : '';
      this.tagFilters.forEach((tag) => { endpoint += `&tags__name=${tag.name}`; });
      this.objFilters.forEach((obj) => { endpoint += `&objectives__title=${obj.title}`; });
      this.capecFilters.forEach((capec) => { endpoint += `&capecs__id=${capec.id}`; });
      await this.fetchPlays(endpoint);
    },
    handlePagination() {
      this.playCount = this.playPagination.count;
      this.queryPrevPage = this.playPagination.previous;
      this.queryNextPage = this.playPagination.next;
      this.numTablePages = Math.ceil(this.plays.length / this.itemsPerPage);

      if (this.queryPrevPage !== null) {
        this.queryPrevPage = new URL(this.queryPrevPage);
        const offset = this.queryPrevPage.searchParams.get('offset');
        this.queryPrevOffset = offset === null ? 0 : parseInt(offset, 10);
      }
      if (this.queryNextPage !== null) {
        this.queryNextPage = new URL(this.queryNextPage);
        const offset = this.queryNextPage.searchParams.get('offset');
        this.queryNextOffset = offset === null ? 0 : parseInt(offset, 10);
      }

      if (this.queryPrevPage === null) {
        this.queryCurrentOffset = 0;
      } else if (this.queryNextPage === null) {
        this.queryCurrentOffset = this.queryNextOffset;
      } else {
        this.queryCurrentOffset = (this.queryPrevOffset + this.queryNextOffset) / 2;
      }

      this.pageStart = this.queryCurrentOffset;
      let nextPageStop = this.queryCurrentOffset + this.itemsPerPage;
      nextPageStop = nextPageStop > this.playCount ? this.playCount : nextPageStop;
      this.pageStop = nextPageStop;
      this.prevPageDisabled = this.pageStart === 0;
      this.nextPageDisabled = this.pageStop === this.playCount;
    },
    async goToNextPage() {
      if (this.pageNum === (this.plays.length / this.itemsPerPage)) {
        await this.fetchPlays(this.queryNextPage.search);
        let nextPageStop = this.queryCurrentOffset + this.itemsPerPage;
        nextPageStop = nextPageStop > this.playCount ? this.playCount : nextPageStop;
        this.pageNum = 1;
        this.pageStart = this.queryCurrentOffset;
        this.pageStop = nextPageStop;
      } else {
        this.pageNum += 1;
        this.pageStart += this.itemsPerPage;
        this.pageStop += this.itemsPerPage;
        if (this.pageStop > this.playCount) this.pageStop = this.playCount;
      }
      this.setDisabled();
    },
    async goToPrevPage() {
      if (this.pageNum === 1 && this.queryNextOffset > 0) {
        await this.fetchPlays(this.queryPrevPage.search);
        this.pageNum = this.numTablePages;
        this.pageStart = this.queryNextOffset - this.itemsPerPage;
        this.pageStop = this.queryNextOffset;
      } else {
        this.pageNum -= 1;
        this.pageStart -= this.itemsPerPage;
        if (this.pageStop === this.playCount) this.pageStop = this.pageStart + this.itemsPerPage;
        else this.pageStop -= this.itemsPerPage;
      }
      this.setDisabled();
    },
    setDisabled() {
      if (this.queryNextPage === null) {
        if (this.pageStop === this.playCount) this.nextPageDisabled = true;
        else this.nextPageDisabled = false;
      } else this.nextPageDisabled = false;
      if (this.queryPrevPage === null) {
        if (this.pageStart === 0) this.prevPageDisabled = true;
        else this.prevPageDisabled = false;
      } else this.prevPageDisabled = false;
    }
  }
};
</script>
